import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ADESAO.DOCUMENTOS.BUSCAR_PAGINADO](context, obj) {
		return await api.documentosAdesao.buscarPaginada(obj)
	},

	async [actionTypes.ADESAO.DOCUMENTOS.CONVIDAR_SIGNATARIOS](context, { idDocumento, emailsSignatarios }) {
		return await api.documentosAdesao.convidarSignatariosProcessoDigital(idDocumento, emailsSignatarios)
	},

	async [actionTypes.ADESAO.DOCUMENTOS.SIGNATARIOS.EXCLUIR](context, { idDocumento, emailsSignatarios }) {
		await api.documentosAdesao.excluirSignatariosProcessoDigital(idDocumento, emailsSignatarios)
	},

	async [actionTypes.ADESAO.DOCUMENTOS.BUSCAR_SIGNATARIOS](context, idDocumento) {
		const { data } = await api.documentosAdesao.buscarSignatariosDocumento(idDocumento)
		return data
	},
}
